var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#F97E60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06439 5.2998C5.74734 5.2998 5.46367 5.36598 5.18 5.4818C4.64603 5.72997 4.26225 6.1436 4.09538 6.67304C3.89514 7.30175 4.01195 8.02973 4.42911 8.77426C5.01313 9.80005 6.06437 10.6108 7.79975 11.9509L8 12.0998L8.20023 11.9509C9.93562 10.6108 10.9869 9.80005 11.5709 8.77426C11.9881 8.02973 12.1049 7.30175 11.9046 6.67304C11.7378 6.1436 11.354 5.72997 10.82 5.4818C10.553 5.34944 10.2527 5.2998 9.93562 5.2998C9.18473 5.2998 8.50059 5.66379 8.1168 6.24287L7.98332 6.44141L7.84982 6.24287C7.51609 5.64725 6.81527 5.2998 6.06439 5.2998Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTag);
export default __webpack_public_path__ + "static/media/like-tag.e187850906d88c915d40f8035cdecfb8.svg";
export { ForwardRef as ReactComponent };